import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown, ShieldAlert, Activity } from 'lucide-react';
const stats = [{
  label: 'Futures P&L',
  value: '+$798.50',
  icon: <TrendingUp size={16} className="text-success" data-id="element-78" />,
  valueColor: 'text-success'
}, {
  label: 'Funding Fees Paid',
  value: '-$42.18',
  icon: <TrendingDown size={16} className="text-danger" data-id="element-79" />,
  valueColor: 'text-danger'
}, {
  label: 'Liquidation Distance',
  value: '28.4%',
  icon: <ShieldAlert size={16} className="text-brand-purple-light" data-id="element-80" />,
  valueColor: 'text-text-primary',
  progress: 28.4
}, {
  label: 'Open Interest',
  value: '$47,891',
  icon: <Activity size={16} className="text-brand-purple-light" data-id="element-81" />,
  valueColor: 'text-text-primary'
}];
export function FuturesPnLSummary() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-82">
      {stats.map((stat, i) => <motion.div key={stat.label} initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.35,
      delay: i * 0.06
    }} className="glass-border rounded-[20px] p-4 flex flex-col justify-between" data-id="element-83">
          <div data-id="element-84">
            <div className="flex items-center justify-between mb-2" data-id="element-85">
              <span className="text-[10px] font-label text-text-tertiary uppercase" data-id="element-86">
                {stat.label}
              </span>
              <div className="p-1.5 bg-background-elevated rounded-lg" data-id="element-87">
                {stat.icon}
              </div>
            </div>
            <div className="flex items-baseline gap-2" data-id="element-88">
              <span className={`text-xl font-numbers font-light ${stat.valueColor}`} data-id="element-89">
                {stat.value}
              </span>
            </div>
          </div>
          {stat.progress !== undefined && <div className="mt-3" data-id="element-90">
              <div className="h-1.5 w-full bg-background-elevated rounded-full overflow-hidden" data-id="element-91">
                <div className={`h-full rounded-full ${stat.progress < 20 ? 'bg-warning' : 'bg-success'}`} style={{
            width: `${stat.progress}%`
          }} data-id="element-92" />
              </div>
            </div>}
        </motion.div>)}
    </div>;
}